import { useContext } from 'react';
import { StyledCell } from '../../../../../../../ResourceAllocationOverview/JiraStats/useTableRows/Row.style';
import ProjectProgressionContext from '../../../../../state/context';
import Icon from 'components/base/Icon';
import { Tooltip } from '@material-ui/core';
import TooltipTrigger from './TooltipTrigger';
import { mapInsightToChipTitle } from '../../../../../Insights/insights.view';
import useInsightsSetting from '../../../../../Insights/useInsights/useInsightsSetting';
import InsightsTooltip from './InsightsTooltip';
import usePmProvider from 'components/hooks/PM/usePmProvider';

const InsightsCell = ({ insightsKeys = [] }) => {
  const {
    state: { selectedInsightKey }
  } = useContext(ProjectProgressionContext);
  const pmProvider = usePmProvider();
  const { getInsightByKey } = useInsightsSetting();

  const insightKeyInView = selectedInsightKey || insightsKeys[0];
  const insight = getInsightByKey(insightKeyInView);

  const insightTitleInView = mapInsightToChipTitle({ insight, pmProvider });
  const shouldShowTooltip = insightsKeys.length > 1;

  if (!insightTitleInView) return null;

  return (
    <StyledCell>
      <Icon
        name='Alert'
        color='neonCarrot'
        size='small'
        style={{ marginRight: '0.5rem' }}
      />
      {insightTitleInView}
      {shouldShowTooltip && (
        <Tooltip
          title={
            <InsightsTooltip
              insightsKeys={insightsKeys}
              pmProvider={pmProvider}
            />
          }
          placement='top'
          style={{ marginLeft: 'auto' }}
        >
          <div>
            <TooltipTrigger value={insightsKeys.length - 1} />
          </div>
        </Tooltip>
      )}
    </StyledCell>
  );
};

export default InsightsCell;
